import { FC, HTMLAttributes } from "react";
import { ReactComponent as MFileArchiveIcon } from "./Assets/min/archive.svg";
import { ReactComponent as MFileInWorkIcon } from "./Assets/min/progress.svg";
import { ReactComponent as MFileCancelIcon } from "./Assets/min/cancel.svg";
import { ReactComponent as MFileOpenIcon } from "./Assets/min/open.svg";
import { ReactComponent as MFileReadyIcon } from "./Assets/min/ready.svg";
import { ReactComponent as MFileWaitingIcon } from "./Assets/min/waiting.svg";
import { ReactComponent as MFileNSIcon } from "./Assets/min/not_specified.svg";
import { ReactComponent as MFileSendIcon } from "./Assets/min/send.svg";
// width = 32 
import { ReactComponent as FileArchiveIcon } from "./Assets/std/archive.svg";
import { ReactComponent as FileInWorkIcon } from "./Assets/std/progress.svg";
import { ReactComponent as FileCancelIcon } from "./Assets/std/cancel.svg";
import { ReactComponent as FileOpenIcon } from "./Assets/std/open.svg";
import { ReactComponent as FileReadyIcon } from "./Assets/std/ready.svg";
import { ReactComponent as FileWaitingIcon } from "./Assets/std/waiting.svg";
import { ReactComponent as FileNSIcon } from "./Assets/std/not_specified.svg";
import { ReactComponent as FileSendIcon } from "./Assets/std/send.svg";

interface IFileStatusIconProps extends HTMLAttributes<HTMLOrSVGElement> {
	iconName: "InWork" | "Archive" | "Cancel" | "Open" | "Ready" | "Sended" | "Waiting" | string;
	min?: boolean;
};

/** Отрисовка иконки статуса */
const StatusIcon: FC<IFileStatusIconProps> = ( { iconName = "", min = false, ...otherProps } ) => {
	if ( min ) {
		switch ( iconName.toLowerCase() ) {
			case "waiting": return <MFileWaitingIcon {...otherProps} />;
			case "inwork": return <MFileInWorkIcon  {...otherProps} />;
			case "archive": return <MFileArchiveIcon {...otherProps} />;
			case "cancel": return <MFileCancelIcon {...otherProps} />;
			case "open": return <MFileOpenIcon {...otherProps} />;
			case "ready": return <MFileReadyIcon {...otherProps} />;
			case "sended": return <MFileSendIcon  {...otherProps} />;
			case "progress": return <MFileInWorkIcon  {...otherProps} />;
			default: return <MFileNSIcon {...otherProps} />;
		}
	}
	else {
		switch ( iconName.toLowerCase() ) {
			case "waiting": return <FileWaitingIcon {...otherProps} />;
			case "inwork": return <FileInWorkIcon  {...otherProps} />;
			case "archive": return <FileArchiveIcon {...otherProps} />;
			case "cancel": return <FileCancelIcon {...otherProps} />;
			case "open": return <FileOpenIcon {...otherProps} />;
			case "ready": return <FileReadyIcon {...otherProps} />;
			case "progress": return <FileWaitingIcon  {...otherProps} />;
			case "sended": return <FileSendIcon  {...otherProps} />;
			default: return <FileNSIcon {...otherProps} />;
		}
	}
};

export default StatusIcon;
